import { Typography } from "@material-tailwind/react";
import SideBar from "../../components/sidebar.tsx/SideBar";
import CustomCard from "../booking/CustomCard";
import DashTable from "./DashTable";
import AuthService from "../../services/authService";
import { useDashBoardQuery } from "../../hooks/useDashboardApi";
import blueImage from "../../assets/images/blue-Card.svg";
import dark from "../../assets/images/dark-Card.svg";
import yellowImage from "../../assets/images/yellow-Card.svg";

function Dashboard() {
  const { data } = useDashBoardQuery();
  const dashboardData = data?.data?.payload?.data;
  return (
    <div className="md:flex">
      <div className="h-full ">
        <SideBar />
      </div>
      <div className="flex-1 p-8 ">
        <Typography placeholder={undefined} className="text-3xl font-semibold">
          Welcome {AuthService.user?.data.firstName}
        </Typography>
        <Typography placeholder={undefined} className="my-4">
          See an overview of all your bookings here
        </Typography>
        <div className="lg:grid lg:grid-cols-3 md:grid md:grid-cols-2 gap-20">
          <CustomCard
            title={dashboardData?.allBookings ?? "..."}
            image={dark}
            subtitle="Total Bookings"
            textColor="text-white"
          />
          <CustomCard
            title={dashboardData?.amountEarned ?? "..."}
            image={blueImage}
            subtitle="Total Income"
          />
          <CustomCard
            title={dashboardData?.pendingBookings ?? "..."}
            image={yellowImage}
            subtitle="Pending Bookings"
          />
        </div>
        <DashTable />
      </div>
    </div>
  );
}

export default Dashboard;
